<template>
  <v-app>
    <div v-if="educational_programs.length">
      <v-autocomplete
          label="Специальность"
          :items="educational_programs"
          item-text="name"
          item-value="id"
          v-model="ep_id"
      >
      </v-autocomplete>
    </div>
    <div v-if="discipline_id">
      <div v-if="teachers.length">
        <v-autocomplete
            label="Выберите преподавателя"
            :items="teachers"
            item-text="name"
            item-value="id"
            v-model="teacher_id"
        >
        </v-autocomplete>
      </div>
      <v-alert v-else
          color="orange"
          type="warning"
      >
        Преподаватели не закреплены, если данный предмет у вас проводился, обратитесь на кафедру, иначе можете пропустить данное тестирование
      </v-alert>
    </div>
    <Survey :survey="survey"/>
  </v-app>
</template>

<script>
import 'survey-core/modern.min.css';
import {Model} from 'survey-core';
import {Survey} from 'survey-vue-ui';
import axios from "axios";

const surveyJson = {
  "locale": "ru",
  "title": "Тест №1",
  "description": "Описание",
  "pages": [],
  "logoPosition": "right",
  "widthMode": "responsive"
};

export default {
  name: 'Attempt',
  components: {
    Survey
  },
  data() {
    let survey = new Model(surveyJson);
    survey.onComplete.add(this.alertResults);
    return {
      survey,
      ep_id: null,
      educational_programs: [],
      discipline_id: null,
      teachers: [],
      teacher_id: null,
    }
  },
  methods: {
    alertResults(sender) {
      const results = JSON.stringify(sender.data);
      alert(results);
    },
    getQuestionnaire() {
      axios({
        method: 'get',
        url: `attempt.json`+ this.discipline_id,
      }).then((response) => {
        this.survey = new Model(response.data.questionnaire);
        this.survey.onComplete.add(this.saveAttempt);
        this.educational_programs = response.data.programs
        this.teachers = response.data.teachers
        this.teacher_id = this.teachers[0].id
      }).catch((error) => {
        return error;
      });
    },
    saveAttempt(sender) {
      const results = JSON.stringify(sender.data);
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      let id = null
      if (this.discipline_id){
        id = this.discipline_id.match(/\d+/)[0]
      }
      axios({
        method: 'put',
        url: 'create_attempt',
        data: {
          answer: {
            answer: results,
            ep_id: this.ep_id,
            discipline_id: id,
            teacher_id: this.teacher_id
          }
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204){
          location.assign('../')
        }
      }).catch((error) => {
        return error;
      });
    },
  },
  mounted() {
    this.discipline_id = window.location.search
    this.getQuestionnaire()
  }
}
</script>